interface Props {
    className: string;
    onClick?: () => void;
    title?: string;
    filled?: boolean
}
export default function emfFavouriteIcon({ className, onClick, title, filled }: Props) {
    if (filled) {
        return (
            <svg onClick={onClick} fill="currentColor" className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="15.28" viewBox="0 0 16 15.28">
                <title>{title}</title>
                <path id="favorite" d="M11.486,10.346A4.514,4.514,0,0,0,8,12a4.511,4.511,0,0,0-8,2.866c0,1.95,1.162,4.205,3.454,6.7a33.275,33.275,0,0,0,4.229,3.822L8,25.626l.317-.238a33.274,33.274,0,0,0,4.229-3.822c2.292-2.5,3.454-4.754,3.454-6.7A4.52,4.52,0,0,0,11.486,10.346Z" transform="translate(0 -10.346)" fill="currentColor" />
            </svg>
        )
    }
    return (
        <svg onClick={onClick} className={className} id="heart" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <title>{title}</title>
            <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143q.09.083.176.171a3 3 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15" />
        </svg>
    )
}